import { ReactElement } from "react";
import { IDelayQMOS } from "../../../../types";
import DelayTable from "../../delays/delayTable";

interface IGeneralPanelProps {
  delays: IDelayQMOS[];
  selected: IDelayQMOS | null;
  setSelected: (delay: IDelayQMOS) => void;
}

const DelayPanel = ({ delays, selected, setSelected }: IGeneralPanelProps): ReactElement => {

  return <DelayTable data={delays} selected={selected} setSelected={setSelected} parentSize={{ width: 0, height: 500 }} />;
};

export default DelayPanel;
